import { render, staticRenderFns } from "./beauty-profile.vue?vue&type=template&id=2af65c58"
import script from "./beauty-profile.vue?vue&type=script&lang=js"
export * from "./beauty-profile.vue?vue&type=script&lang=js"
import style0 from "./beauty-profile.vue?vue&type=style&index=0&id=2af65c58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports